import React from 'react';
import PropTypes from 'prop-types';
import Impression from './impression';

var CCProductImpression = function CCProductImpression(props) {
  var impressionProps = {
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    id: props.id,
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    children: props.children,
    eventName: 'CC_IMPRESSION_EVENT',
    eventData: {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      cardNetworkFilter: props.cardNetworkFilter,
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      creditScoreFilter: props.creditScoreFilter,
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      feesFilter: props.feesFilter,
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      financialInstitutionsFilter: props.financialInstitutionsFilter,
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      monthlySpendFilter: props.monthlySpendFilter,
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      yearsWithCardFilter: props.yearsWithCardFilter,
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      issuer: props.issuer,
      impressionHeader: {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productId: props.productId,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productSlug: props.productSlug,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productLocation: props.productLocation,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        category: props.category,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productInstance: props.productInstance,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        linkType: props.linkType,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        sponsored: props.sponsored,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        monetizing: props.monetizing,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productPosition: props.productPosition,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        sectionPosition: props.sectionPosition,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        offerVersionId: props.offerVersionId,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        pageNumber: props.pageNumber,
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        productDisplayDriver: props.productDisplayDriver
      }
    }
  };
  return /*#__PURE__*/React.createElement(Impression, impressionProps);
};

CCProductImpression.propTypes = {
  id: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  productSlug: PropTypes.string.isRequired,
  productLocation: PropTypes.string.isRequired,
  children: PropTypes.element,
  category: PropTypes.string,
  productInstance: PropTypes.string,
  linkType: PropTypes.string,
  sponsored: PropTypes.bool,
  monetizing: PropTypes.bool,
  productPosition: PropTypes.number,
  sectionPosition: PropTypes.number,
  offerVersionId: PropTypes.string,
  pageNumber: PropTypes.number,
  cardNetworkFilter: PropTypes.string,
  creditScoreFilter: PropTypes.string,
  feesFilter: PropTypes.string,
  financialInstitutionsFilter: PropTypes.string,
  monthlySpendFilter: PropTypes.number,
  yearsWithCardFilter: PropTypes.number,
  issuer: PropTypes.string,
  productDisplayDriver: PropTypes.string
};
CCProductImpression.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types -- directive added automatically by Shepherd migration
  productLocation: 'body',
  productInstance: 'unknown',
  linkType: 'unknown',
  category: 'Credit Card'
};
export default CCProductImpression;